import React, { memo } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { CircularProgress, Grid, Stack, Typography } from "@mui/material";
import CheckAndReturn from "../../utility/CheckAndReturn";
import LoaderNew from "../Loader/LoaderNew";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { ITEM_LEDGER_TABLE_HEADERS } from "./itemLedgerFilterUtils";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#4CB5F5", //theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingTop: 1,
    paddingBottom: 1,
    marginTop: 0,
    marginBottom: 0,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const QuantityWithArrow = ({ type, quantity }) => {
  const redTypes = ["Invoice", "Challan", "Vendor Challan"];
  const greenTypes = ["Credit Note", "Purchase"]; // Stock Update yaha nahi rakhenge

  const isRed = redTypes.includes(type);
  const isGreen = greenTypes.includes(type);

  // 🔥 Special Logic for Stock Update
  if (type === "Stock Update") {
    const isNegative = Number(quantity) < 0;

    return (
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        sx={{ color: isNegative ? "red" : "green" }}
      >
        {isNegative ? (
          <ArrowDownwardIcon fontSize="small" />
        ) : (
          <ArrowUpwardIcon fontSize="small" />
        )}
        <Typography variant="body2">
          {Math.abs(quantity)}
        </Typography>
      </Stack>
    );
  }

  // 👉 Agar koi aur type hai aur red/green list me nahi hai
  if (!isRed && !isGreen) {
    return <Typography variant="body2">{quantity}</Typography>;
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{ color: isRed ? "red" : "green" }}
    >
      {isRed ? (
        <ArrowUpwardIcon fontSize="small" />
      ) : (
        <ArrowDownwardIcon fontSize="small" />
      )}
      <Typography variant="body2">
        {quantity}
      </Typography>
    </Stack>
  );
};

//FUNCTION
const ItemLedgerTable = ({
  itemLedger,
  selectedItem,
  itemLedgerLoading,
  totalCount = 0,
}) => {
  const formatReturnable = (value) => {
    if (value === null || value === undefined) return "N/A";
    return value ? "Yes" : "No";
  };

  return (
    <>
      <Grid container alignItems={"center"} spacing={2} mb={1}>
        <Grid
          container
          item
          xs={12}
          md={4}
          justifyContent={{ xs: "center", md: "flex-start" }}
        >
          <Stack direction={"row"}>
            <Typography variant="body1" fontWeight={600}>
              Opening Quantity:
            </Typography>
            <Typography variant="body1" ml={2}>
              {itemLedgerLoading === true ? (
                <LoaderNew />
              ) : (
                selectedItem?.openingquantity
              )}
            </Typography>
          </Stack>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={4}
          justifyContent={{ xs: "center", md: "center" }}
        >
          <Box flex={1} textAlign="center">
            <Typography variant="h5" color="#1e61b4" fontWeight={700}>
              {itemLedgerLoading === true ? (
                <LoaderNew />
              ) : (
                selectedItem?.item_name
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={4}
          justifyContent={{ xs: "center", md: "flex-end" }}
        >
          <Stack direction={"row"}>
            <Typography variant="body1" fontWeight={600}>
              Actual Quantity:
            </Typography>
            <Typography variant="body1" ml={2}>
              {itemLedgerLoading === true ? (
                <LoaderNew />
              ) : (
                selectedItem?.actualquantity
              )}
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      <TableContainer component={Paper}>
        <Box sx={{ overflowX: "auto" }}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">S.No</StyledTableCell>
                {ITEM_LEDGER_TABLE_HEADERS.map((column) => (
                  <StyledTableCell key={column.id} align="left">
                    {column.label}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            {itemLedgerLoading === true ? (
              <TableRow>
                <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                  <Box>
                    <LoaderNew />
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              <TableBody>
                {itemLedger.length > 0 ? (
                  itemLedger.map((row, index) => (
                    <StyledTableRow key={`${row.type}-${row.entity_number}-${row.date}-${index}`}>
                      <StyledTableCell align="left">
                        {index + 1}
                      </StyledTableCell>
                      <StyledTableCell align="left">{row.type}</StyledTableCell>
                      <StyledTableCell align="left">
                        {row.entity_number}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.customer_name}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.location_name}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <QuantityWithArrow
                          type={row.type}
                          quantity={row.quantity}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="left">{row.rate}</StyledTableCell>
                      <StyledTableCell align="left">
                        {CheckAndReturn.roundToInteger(row.amount)}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {formatReturnable(row.is_returnable)}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {CheckAndReturn.transformToDate3(row.date)}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={12}
                      sx={{
                        textAlign: "center",
                        color: "red",
                        fontSize: "16px",
                      }}
                    >
                      <div>
                        <p>
                          <b>
                            {totalCount > 0
                              ? "No records match the selected filter."
                              : "No Item Found."}
                          </b>
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </Box>
      </TableContainer>
    </>
  );
};

export default memo(ItemLedgerTable);
